import React from "react";
const InputsContext = React.createContext({});
export const InputsProvider = InputsContext.Provider;
export default InputsContext;
